import { render, staticRenderFns } from "./VImage.vue?vue&type=template&id=2d882142&scoped=true"
import script from "./VImage.vue?vue&type=script&lang=js"
export * from "./VImage.vue?vue&type=script&lang=js"
import style0 from "./VImage.vue?vue&type=style&index=0&id=2d882142&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d882142",
  null
  
)

export default component.exports